import { Colors, Storage } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
let currentLanguageIndex = 0;

const languagesLinks = [
  { id: 0, title: 'English', lng: 'en-US' },
  { id: 1, title: 'Português', lng: 'pt' },
  { id: 2, title: 'Español', lng: 'es' },
];
export default class Language extends Lightning.Component {
  static _template() {
    return {
      Title: {
        y: 520,
        x: 360,
      },
      CurrentValue: {
        y: 525,
        x: 970,
        text: { textColor: Colors('#FAFAFA').get(), fontFace: 'OpenSans-Regular', fontSize: 36 },
      },
      Border: {
        x: 320,
        y: 510,
        collision: true,
        texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
      },
    };
  }
  get _Title() {
    return this.tag('Title');
  }
  get _Border() {
    return this.tag('Border');
  }
  get _CurrentValue() {
    return this.tag('CurrentValue');
  }
  set lng(val) {
    return (this._lng = val);
  }
  set profileId(val) {
    return (this._profileId = val);
  }
  _changeValue() {
    switch (this._CurrentValue.text._text) {
      case 'English':
        currentLanguageIndex = 0;
        break;
      case 'Português':
        currentLanguageIndex = 1;
        break;
      case 'Español':
        currentLanguageIndex = 2;
        break;
    }
    const nextLanguageIndex = (currentLanguageIndex + 1) % languagesLinks.length;
    const nextLanguage = languagesLinks[nextLanguageIndex];
    currentLanguageIndex += 1;
    this._CurrentValue.patch({
      text: {
        text: nextLanguage.title,
      },
      lng: nextLanguage.lng,
      index: nextLanguageIndex,
    });
  }

  _handleEnter() {
    this._changeValue();
  }
  _firstEnable() {
    this._Title.patch({
      color: Colors('#D6D6D6').get(),
      text: {
        text: 'Language',
        textColor: Colors('#D6D6D6').get(),
      },
    });
    this._CurrentValue.patch({
      text: {
        text: 'English',
        textColor: Colors('#D6D6D6').get(),
      },
      lng: 'en-US',
    });
  }
  _focus() {
    this._Title.patch({
      color: Colors('#fafafa').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#02AC25').get(), false),
    });
    this._CurrentValue.patch({
      text: {
        textColor: Colors('#fafafa').get(),
      },
    });
  }
  _unfocus() {
    this._Title.patch({
      color: Colors('#D6D6D6').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
    });
    this._CurrentValue.patch({
      text: {
        textColor: Colors('#D6D6D6').get(),
      },
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Language');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._changeValue();
  }
}
